'use client';

import type React from 'react';
import { ClerkProvider } from '@clerk/nextjs';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './theme-provider';
import { I18nProvider } from '@/lib/i18n';
import { PostHogProvider } from './PostHogProvider';
const queryClient = new QueryClient();
export function Providers({
  children
}: {
  children: React.ReactNode;
}) {
  return <PostHogProvider data-sentry-element="PostHogProvider" data-sentry-component="Providers" data-sentry-source-file="providers.tsx">
      <ClerkProvider appearance={{
      layout: {
        socialButtonsVariant: 'blockButton'
      }
    }} data-sentry-element="ClerkProvider" data-sentry-source-file="providers.tsx">
        <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-source-file="providers.tsx">
          <ThemeProvider attribute="class" defaultTheme="light" enableSystem data-sentry-element="ThemeProvider" data-sentry-source-file="providers.tsx">
            <I18nProvider data-sentry-element="I18nProvider" data-sentry-source-file="providers.tsx">{children}</I18nProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </ClerkProvider>
    </PostHogProvider>;
}